@if (showErrorPopup$ | async; as show_Popup) {
  <app-errors
    [visible]="show_Popup"
    (onHide)="closeDialog()"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="staff-permission-error-popup"
  />
}
@if (loading | async; as loading) {
  <div
    class="p-field p-col-12 p-md-6"
    aria-label="staff-permission-loading-skeleton"
  >
    <p-skeleton animation="wave" styleClass="p-mb-2 mt-3" />
    <p-skeleton animation="wave" width="10rem" styleClass="p-mb-2 mt-3" />
    <p-skeleton
      animation="wave"
      width="12rem"
      styleClass="p-mb-2 mt-3"
      height="3rem"
    />
    <p-skeleton animation="wave" height="10rem" styleClass="p-mb-2 mt-3" />
    <p-skeleton
      animation="wave"
      width="12rem"
      styleClass="p-mb-2 mt-3"
      height="3rem"
    />
    <p-skeleton animation="wave" width="10rem" styleClass="p-mb-2 mt-3" />
  </div>
}
@if (staffPermissionForm && (loading | async) === false) {
  <form
    #form="ngForm"
    [formGroup]="staffPermissionForm"
    (ngSubmit)="saveStaffPermission()"
    (keydown.enter)="$event.preventDefault()"
    aria-label="staff-permission-form"
  >
    <!-- Card -->
    <div
      [ngClass]="insideDialog() ? '-m-3' : 'shadow-2'"
      class="surface-50 p-3"
    >
      <!-- Above classes to be replaced with these when on popup view -->
      <!-- <div class="surface-50 -m-3 p-3"> -->
      <!-- Above classes to be replaced with these when on popup view -->
      <div class="grid grid-nogutter text-sm px-2">
        <div class="col-12">
          <label
            for="name"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="template-name-label"
            >{{
              'ADMIN.STAFF_PERMISSION.STAFF_PERMISSION_TEMPLATE_NAME'
                | translate
            }}
            <sup class="p-error">*</sup></label
          >
          <input
            id="name"
            type="text"
            placeholder="{{ 'ADMIN.STAFF_PERMISSION.ADD_NAME' | translate }}"
            formControlName="name"
            pInputText
            class="w-full text-sm"
            aria-label="template-name-input"
          />
          @if (Name?.touched && Name?.invalid) {
            <app-error-msg
              [errors]="Name?.errors"
              [fieldLabel]="'ADMIN.STAFF_PERMISSION.ADD_NAME' | translate"
            />
          }
        </div>
        <div class="col-12 mt-4">
          <label
            for="description"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="template-description-label"
            >{{
              'ADMIN.STAFF_PERMISSION.STAFF_PERMISSION_TEMPLATE_DESCRIPTION'
                | translate
            }}
            <sup class="p-error">*</sup></label
          >
          <textarea
            id="description"
            placeholder="{{ 'ADMIN.STAFF_PERMISSION.ADD_DESC' | translate }}"
            formControlName="description"
            pInputText
            class="w-full text-sm"
            aria-label="template-description-input"
          ></textarea>
          @if (Description?.touched && Description?.invalid) {
            <app-error-msg
              [errors]="Description?.errors"
              [fieldLabel]="'ADMIN.STAFF_PERMISSION.ADD_DESC' | translate"
            />
          }
        </div>
      </div>
      <p-divider styleClass="my-3" />
      <div class="text-sm p-2">
        <div class="grid align-items-center">
          <div class="col-12 md:col-7">
            <span
              class="font-semibold"
              aria-label="permission-controls-header"
              >{{
                'ADMIN.STAFF_PERMISSION.PERMISSION_CONTROLS' | translate
              }}</span
            >
          </div>
          <div class="col-12 md:col-5">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"
                ><i class="fa fa-search" aria-label="search-icon"></i
              ></span>
              <input
                class="text-sm"
                type="text"
                pInputText
                placeholder="{{
                  'ADMIN.STAFF_PERMISSION.SEARCH_PERMISSION_CONTROL' | translate
                }}"
                id="searchPermission"
                #searchPermission
                aria-label="search-permission-input"
              />
            </div>
          </div>
        </div>
        <!-- Client Controls -->
        <div class="flex flex-column mt-3 w-full">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            for="clientControl"
            aria-label="client-controls-label"
          >
            <div class="flex align-items-center">
              <p-toggleSwitch
                id="clientControl"
                formControlName="clientControl"
                aria-label="client-controls-switch"
              />
              <span class="ml-2 -mt-2">
                <span
                  [innerHTML]="
                    'ADMIN.STAFF_PERMISSION.CLIENT_CONTROLS'
                      | translate
                      | highlight: searchPermission.value
                  "
                ></span>
                <i
                  class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                  [pTooltip]="
                    'ADMIN.STAFF_PERMISSION.CLIENT_CONTROLS_TIP' | translate
                  "
                  tooltipStyleClass="text-xs"
                  tooltipPosition="top"
                  aria-label="client-controls-help"
                ></i
              ></span>
            </div>
          </label>
          <div
            class="surface-0 px-1 py-2 border-1 border-300 w-full border-round"
          >
            <div class="grid grid-nogutter">
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_do_client_profiles"
                    aria-label="create-prospects-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CREATE_PROSPECTS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CREATE_PROSPECTS_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="create-prospects-help"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_manage_client_profiles"
                    aria-label="manage-client-profiles-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.EDIT_MANAGE_CLIENT_PROFILE'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.EDIT_MANAGE_CLIENT_PROFILE_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-client-profiles-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_do_member_communication"
                    aria-label="send-communication-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CAN_SEND_COMMUNICATION'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_SEND_COMMUNICATION_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="send-communication-help"
                    ></i
                  ></span>
                </div>
              </div>
              @if (false) {
                <div class="col-12 md:col-4">
                  <div class="flex align-items-center m-2">
                    <p-toggleSwitch
                      formControlName="can_manage_member_communication"
                      aria-label="send-bulk-comms-switch"
                    />
                    <span class="ml-2 text-sm -mt-2 flex align-items-center">
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.SEND_BULK_COMMS'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                      <i
                        class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                        [pTooltip]="
                          'ADMIN.STAFF_PERMISSION.SEND_BULK_COMMS_TIP'
                            | translate
                        "
                        tooltipStyleClass="text-xs"
                        tooltipPosition="top"
                        aria-label="send-bulk-comms-help"
                      ></i
                    ></span>
                  </div>
                </div>
              }

              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_admin_member_communication"
                    aria-label="client-comm-admin-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CLIENT_COMM_ADMIN'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CLIENT_COMM_ADMIN_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="client-comm-admin-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_admin_client_profiles"
                    aria-label="admin-client-profiles-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CAN_ADMIN_CLIENT_PROFILES'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_ADMIN_CLIENT_PROFILES_TOOLTIP_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="admin-client-profiles-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_do_templated_member_communication"
                    aria-label="client-comm-templated-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CLIENT_COMM_TEMPLATED'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CLIENT_COMM_TEMPLATED_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="client-comm-templated-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_do_free_form_manage_member_communication"
                    aria-label="client-comm-freeform-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CLIENT_COMM_FREEFORM'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CLIENT_COMM_FREEFORM_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="client-comm-freeform-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_delete_clients"
                    aria-label="delete-clients-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CAN_DELETE_CLIENTS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_DELETE_CLIENTS_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="delete-clients-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_reactivate_access_control"
                    aria-label="reactivate-access-control-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CAN_REACTIVATE_ACCESS_CONTROL'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_REACTIVATE_ACCESS_CONTROL_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="reactivate-access-control-help"
                    ></i
                  ></span>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <!-- Client Communication Admin -->
        <div class="flex flex-column mt-5 w-full">
          <label
            for="clientCommunicationAdmin"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="client-communication-admin-label"
          >
            <div class="flex align-items-center flex-wrap gap-2">
              <p-toggleSwitch
                id="clientCommunicationAdmin"
                formControlName="clientCommunication"
                aria-label="client-communication-admin-switch"
              />
              <span class="flex align-items-center flex-wrap gap-1">
                <span
                  [innerHTML]="
                    'ADMIN.STAFF_PERMISSION.CLIENT_COMM_ADMIN'
                      | translate
                      | highlight: searchPermission.value
                  "
                ></span>
                <i
                  class="text-500 text-xl fa fa-question-circle font-light cursor-pointer"
                  [pTooltip]="
                    'ADMIN.STAFF_PERMISSION.CLIENT_COMM_ADMIN_TIP' | translate
                  "
                  tooltipStyleClass="text-xs"
                  tooltipPosition="top"
                  aria-label="client-communication-admin-help"
                ></i>
              </span>
            </div>
          </label>
          <div
            class="surface-0 px-2 py-3 border-1 border-300 w-full border-round"
          >
            <div class="grid grid-nogutter">
              <div class="col-12 sm:col-6 xl:col-4">
                <div
                  class="flex align-items-start gap-2 m-1 p-2 border-round hover:surface-100 transition-colors transition-duration-150"
                >
                  <p-toggleSwitch
                    id="manageMembership"
                    formControlName="can_manage_membership_basic"
                    aria-label="manage-membership-switch"
                    class="flex-shrink-0 mt-1"
                  />
                  <span class="text-sm line-height-3 flex-1">
                    <button
                      type="button"
                      class="p-0 border-none bg-transparent text-left cursor-pointer text-color line-height-3"
                      (click)="togglePermission('can_manage_membership_basic')"
                      aria-label="toggle-manage-membership"
                    >
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.MANAGE_MEMBERSHIP'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                    </button>
                    <i
                      class="text-500 text-base fa fa-question-circle font-light cursor-pointer ml-1 vertical-align-middle"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_MEMBERSHIP_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-membership-help"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="col-12 sm:col-6 xl:col-4">
                <div
                  class="flex align-items-start gap-2 m-1 p-2 border-round hover:surface-100 transition-colors transition-duration-150"
                >
                  <p-toggleSwitch
                    id="manageMembershipAdmin"
                    formControlName="can_admin_membership"
                    aria-label="manage-membership-admin-switch"
                    class="flex-shrink-0 mt-1"
                  />
                  <span class="text-sm line-height-3 flex-1">
                    <button
                      type="button"
                      class="p-0 border-none bg-transparent text-left cursor-pointer text-color line-height-3"
                      (click)="togglePermission('can_admin_membership')"
                      aria-label="toggle-manage-membership-admin"
                    >
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.MANAGE_MEMBERSHIP_ADMIN'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                    </button>
                    <i
                      class="text-500 text-base fa fa-question-circle font-light cursor-pointer ml-1 vertical-align-middle"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_MEMBERSHIP_ADMIN_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-membership-admin-help"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="col-12 sm:col-6 xl:col-4">
                <div
                  class="flex align-items-start gap-2 m-1 p-2 border-round hover:surface-100 transition-colors transition-duration-150"
                >
                  <p-toggleSwitch
                    formControlName="can_force_activate_subscription"
                    aria-label="force-activate-subscription-switch"
                    class="flex-shrink-0 mt-1"
                  />
                  <span class="text-sm line-height-3 flex-1">
                    <button
                      type="button"
                      class="p-0 border-none bg-transparent text-left cursor-pointer text-color line-height-3"
                      (click)="togglePermission('can_force_activate_subscription')"
                      aria-label="toggle-force-activate-subscription"
                    >
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.CAN_FORCE_ACTIVATE_SUBSCRIPTION'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                    </button>
                    <i
                      class="text-500 text-base fa fa-question-circle font-light cursor-pointer ml-1 vertical-align-middle"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_FORCE_ACTIVATE_SUBSCRIPTION_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="force-activate-subscription-help"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="col-12 sm:col-6 xl:col-4">
                <div
                  class="flex align-items-start gap-2 m-1 p-2 border-round hover:surface-100 transition-colors transition-duration-150"
                >
                  <p-toggleSwitch
                    formControlName="can_manage_staff"
                    aria-label="manage-staff-switch"
                    class="flex-shrink-0 mt-1"
                  />
                  <span class="text-sm line-height-3 flex-1">
                    <button
                      type="button"
                      class="p-0 border-none bg-transparent text-left cursor-pointer text-color line-height-3"
                      (click)="togglePermission('can_manage_staff')"
                      aria-label="toggle-manage-staff"
                    >
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.CAN_MANAGE_STAFF'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                    </button>
                    <i
                      class="text-500 text-base fa fa-question-circle font-light cursor-pointer ml-1 vertical-align-middle"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_MANAGE_STAFF_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-staff-help"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="col-12 sm:col-6 xl:col-4">
                <div
                  class="flex align-items-start gap-2 m-1 p-2 border-round hover:surface-100 transition-colors transition-duration-150"
                >
                  <p-toggleSwitch
                    formControlName="can_admin_staff"
                    aria-label="admin-staff-switch"
                    class="flex-shrink-0 mt-1"
                  />
                  <span class="text-sm line-height-3 flex-1">
                    <button
                      type="button"
                      class="p-0 border-none bg-transparent text-left cursor-pointer text-color line-height-3"
                      (click)="togglePermission('can_admin_staff')"
                      aria-label="toggle-admin-staff"
                    >
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.CAN_ADMIN_STAFF'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                    </button>
                    <i
                      class="text-500 text-base fa fa-question-circle font-light cursor-pointer ml-1 vertical-align-middle"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_ADMIN_STAFF_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="admin-staff-help"
                    ></i>
                  </span>
                </div>
              </div>
              @if (false) {
                <div class="col-12 sm:col-6 xl:col-4">
                  <div class="flex align-items-start gap-2 m-1 p-2">
                    <p-toggleSwitch
                      formControlName="can_manage_staff_permission_template"
                      aria-label="manage-staff-permission-switch"
                      class="flex-shrink-0 mt-1"
                    />
                    <span class="text-sm line-height-3 flex-1">
                      <span
                        [innerHTML]="
                          'ADMIN.STAFF_PERMISSION.CREATE_EDIT_STAFF_PERMISSION'
                            | translate
                            | highlight: searchPermission.value
                        "
                      ></span>
                      <i
                        class="text-500 text-base fa fa-question-circle font-light cursor-pointer ml-1"
                        [pTooltip]="
                          'ADMIN.STAFF_PERMISSION.CREATE_EDIT_STAFF_PERMISSION_TIP'
                            | translate
                        "
                        tooltipStyleClass="text-xs"
                        tooltipPosition="top"
                        aria-label="manage-staff-permission-help"
                      ></i>
                    </span>
                  </div>
                </div>
              }
            </div>

            <p-divider styleClass="my-2" />

            <div class="grid grid-nogutter">
              <div class="col-12 md:col-6">
                <div class="p-2">
                  <label
                    for="singleStaffDiscount"
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    aria-label="single-staff-discount-label"
                  >
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.SINGLE_STAFF_DISS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.SINGLE_STAFF_DISS_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="single-staff-discount-help"
                    ></i>
                  </label>
                  <div class="p-inputgroup align-items-center w-full max-w-20rem">
                    <span class="p-inputgroup-addon text-sm flex-shrink-0">
                      <i
                        class="fa fa-percentage text-xs"
                        aria-label="percentage-icon"
                      ></i>
                    </span>
                    <app-input-number
                      class="flex-1 min-w-0"
                      [formGroup]="staffPermissionForm"
                      [controlName]="SingleStaffDiscount"
                      [styleClass]="'w-full text-sm'"
                      [conditionToFormat]="false"
                      aria-label="single-staff-discount-input"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6">
                <div class="p-2">
                  <label
                    for="recurringStaffDiscount"
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    aria-label="recurring-staff-discount-label"
                  >
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.RECURRING_STAFF_DISCOUNT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.RECURRING_STAFF_DISCOUNT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="recurring-staff-discount-help"
                    ></i>
                  </label>
                  <div class="p-inputgroup align-items-center w-full max-w-20rem">
                    <span class="p-inputgroup-addon text-sm flex-shrink-0">
                      <i
                        class="fa fa-percentage text-xs"
                        aria-label="percentage-icon"
                      ></i>
                    </span>
                    <app-input-number
                      class="flex-1 min-w-0"
                      [formGroup]="staffPermissionForm"
                      [controlName]="RecurringStaffDiscount"
                      [styleClass]="'w-full text-sm'"
                      [conditionToFormat]="false"
                      aria-label="recurring-staff-discount-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Scheduling Controls -->
        <div class="flex flex-column mt-5 w-full">
          <label
            for="scheduling"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="scheduling-controls-label"
          >
            <div class="flex align-items-center">
              <p-toggleSwitch
                id="scheduling"
                formControlName="scheduling"
                aria-label="scheduling-controls-switch"
              />
              <span class="ml-2 -mt-2">
                <span
                  [innerHTML]="
                    'ADMIN.STAFF_PERMISSION.SCHEDULING_CONTROLS'
                      | translate
                      | highlight: searchPermission.value
                  "
                ></span>
                <i
                  class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                  [pTooltip]="
                    'ADMIN.STAFF_PERMISSION.SCHEDULING_CONTROLS_TIP' | translate
                  "
                  tooltipStyleClass="text-xs"
                  tooltipPosition="top"
                  aria-label="scheduling-controls-help"
                ></i
              ></span>
            </div>
          </label>
          <div
            class="surface-0 px-1 py-2 border-1 border-300 w-full border-round"
          >
            <div class="grid grid-nogutter">
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    id="manageAppointments"
                    formControlName="can_manage_appointments"
                    aria-label="manage-appointments-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_APPOINTMENT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_APPOINTMENT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-appointments-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_manage_class"
                    aria-label="manage-classes-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_CLASSES'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_CLASSES_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-classes-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_admin_class"
                    aria-label="admin-class-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.ADMIN_CLASS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.ADMIN_CLASS_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="admin-class-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    id="adminAppointments"
                    formControlName="can_admin_appointments"
                    aria-label="admin-appointments-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.ADMIN_APPOINTMENT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    >
                    </span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_ADMIN_APPOINTMENT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="admin-appointments-help"
                    ></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Billing & Financial Controls -->
        <div class="flex flex-column mt-5 w-full">
          <label
            for="billingAndFinance"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="billing-finance-label"
          >
            <div class="flex align-items-center">
              <p-toggleSwitch
                id="billingAndFinance"
                formControlName="billingAndFinance"
                aria-label="billing-finance-switch"
              />
              <span class="ml-2 -mt-2">
                <span
                  [innerHTML]="
                    'ADMIN.STAFF_PERMISSION.BILL_FIN_CONTROLS'
                      | translate
                      | highlight: searchPermission.value
                  "
                ></span>
                <i
                  class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                  [pTooltip]="
                    'ADMIN.STAFF_PERMISSION.BILL_FIN_CONTROLS_TIP' | translate
                  "
                  tooltipStyleClass="text-xs"
                  tooltipPosition="top"
                  aria-label="billing-finance-help"
                ></i
              ></span>
            </div>
          </label>
          <div
            class="surface-0 px-1 py-2 border-1 border-300 w-full border-round"
          >
            <div class="grid grid-nogutter">
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_do_billing"
                    aria-label="new-signup-billing-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.NEW_SIGNUP_BILLING'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.NEW_SIGNUP_BILLING_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="new-signup-billing-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_admin_billing"
                    aria-label="admin-billing-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.ADMIN_BILLING'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.ADMIN_BILLING_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="admin-billing-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    id="billingOtherTenant"
                    formControlName="can_do_billing_at_other_tenant"
                    aria-label="billing-other-tenant-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CAN_DO_BILLING_AT_OTHER_TENANT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_DO_BILLING_AT_OTHER_TENANT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="billing-other-tenant-help"
                    ></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Retail Controls -->
        <div class="flex flex-column mt-5 w-full">
          <label
            for="retailControls"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="retail-controls-label"
          >
            <div class="flex align-items-center">
              <p-toggleSwitch
                id="retailControls"
                formControlName="retailControls"
                aria-label="retail-controls-switch"
              />
              <span class="ml-2 -mt-2">
                <span
                  [innerHTML]="
                    'ADMIN.STAFF_PERMISSION.RETAIL_CONTROLS'
                      | translate
                      | highlight: searchPermission.value
                  "
                ></span>
                <i
                  class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                  [pTooltip]="
                    'ADMIN.STAFF_PERMISSION.RETAIL_CONTROLS_TIP' | translate
                  "
                  tooltipStyleClass="text-xs"
                  tooltipPosition="top"
                  aria-label="retail-controls-help"
                ></i
              ></span>
            </div>
          </label>
          <div
            class="surface-0 px-1 py-2 border-1 border-300 w-full border-round"
          >
            <div class="grid grid-nogutter">
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_manage_retail"
                    aria-label="manage-retail-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_RETAIL'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.MANAGE_RETAIL_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="manage-retail-help"
                    ></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Reporting Controls -->
        <div class="flex flex-column mt-5 w-full">
          <label
            for="reporting"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="reporting-controls-label"
          >
            <div class="flex align-items-center">
              <p-toggleSwitch
                id="reporting"
                formControlName="reporting"
                aria-label="reporting-controls-switch"
              />
              <span class="ml-2 -mt-2">
                <span
                  [innerHTML]="
                    'ADMIN.STAFF_PERMISSION.REPORTING_CONTROLS'
                      | translate
                      | highlight: searchPermission.value
                  "
                ></span>
                <i
                  class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                  [pTooltip]="
                    'ADMIN.STAFF_PERMISSION.REPORTING_CONTROLS_TIP' | translate
                  "
                  tooltipStyleClass="text-xs"
                  tooltipPosition="top"
                  aria-label="reporting-controls-help"
                ></i
              ></span>
            </div>
          </label>
          <div
            class="surface-0 px-1 py-2 border-1 border-300 w-full border-round"
          >
            <div class="grid grid-nogutter">
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    id="financeReports"
                    formControlName="can_see_reports_finance"
                    aria-label="finance-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_FINANCE_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_FINANCE_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="finance-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_clients"
                    aria-label="client-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_CLIENT_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_CLIENT_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="client-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_operational"
                    aria-label="operational-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_OPP_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_OPP_REPORT_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="operational-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_appointment"
                    aria-label="appointment-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_APPOINTMENT_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_APPOINTMENT_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="appointment-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_class"
                    aria-label="class-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_CLASS_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_CLASS_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="class-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_sales"
                    aria-label="sales-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_SALE_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_SALE_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="sales-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_staff"
                    aria-label="staff-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_STAFF_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_STAFF_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="staff-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_marketing"
                    aria-label="marketing-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_MKT_REPORTS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_MKT_REPORTS_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="marketing-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_security"
                    aria-label="security-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_SEC_REPORTS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_SEC_REPORTS_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="security-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_see_reports_retail"
                    aria-label="retail-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.VIEW_RETAIL_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.VIEW_RETAIL_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="retail-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_export_reports"
                    aria-label="export-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.CAN_EX_REPORTS'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.CAN_EX_REPORTS_TIP' | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="export-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="can_export_report_with_sensetive_info"
                    aria-label="sensitive-info-reports-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.PERSONAL_ID_INFO'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.PERSONAL_ID_INFO_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="sensitive-info-reports-help"
                    ></i
                  ></span>
                </div>
              </div>
              <div class="col-12 md:col-4">
                <div class="flex align-items-center m-2">
                  <p-toggleSwitch
                    formControlName="sales_day_end_report"
                    aria-label="sales-day-end-report-switch"
                  />
                  <span class="ml-2 text-sm -mt-2 flex align-items-center">
                    <span
                      [innerHTML]="
                        'ADMIN.STAFF_PERMISSION.SALES_DAY_END_REPORT'
                          | translate
                          | highlight: searchPermission.value
                      "
                    ></span>
                    <i
                      class="text-500 text-xl fa fa-question-circle font-light cursor-pointer ml-1"
                      [pTooltip]="
                        'ADMIN.STAFF_PERMISSION.SALES_DAY_END_REPORT_TIP'
                          | translate
                      "
                      tooltipStyleClass="text-xs"
                      tooltipPosition="top"
                      aria-label="sales-day-end-report-help"
                    >
                    </i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (!insideDialog()) {
      <div class="flex align-items-center justify-content-between my-3">
        <button
          pButton
          type="button"
          label="{{ 'ADMIN.COMMON.CANCEL' | translate }}"
          class="text-sm p-button-text"
          (click)="close.emit(true)"
          aria-label="cancel-permission-template-button"
        ></button>
        <button
          pButton
          type="submit"
          label="{{ 'ADMIN.COMMON.SAVE' | translate }}"
          class="text-sm mr-2"
          [loading]="isFormSubmitting"
          aria-label="save-permission-template-button"
        ></button>
      </div>
    }
    <!-- Card -->
  </form>
}
